export default __webpack_public_path__ + "LifeTime_OnePager_Aerzte19908d6438c845960991c5c0e71ea0fc.pdf";